const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getReportTypes(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.category) params.append('category', filters.category);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/report-types${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch report types');
  }
  
  const data = await response.json();
  return data.reportTypes;
}

export async function getReportType(orgId, reportTypeId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-types/${reportTypeId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Report type not found');
    }
    throw new Error('Failed to fetch report type');
  }
  
  const data = await response.json();
  return data.reportType;
}
